var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmptyShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M100.983 101.187L80.9834 81.1875",
    stroke: "url(#paint0_linear_1326_20723)",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M55.9834 91.1875C75.3134 91.1875 90.9834 75.5175 90.9834 56.1875C90.9834 36.8575 75.3134 21.1875 55.9834 21.1875C36.6534 21.1875 20.9834 36.8575 20.9834 56.1875C20.9834 75.5175 36.6534 91.1875 55.9834 91.1875Z",
    stroke: "url(#paint1_linear_1326_20723)",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1326_20723",
    x1: 79.5146,
    y1: 81.1875,
    x2: 100.983,
    y2: 101.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1326_20723",
    x1: 15.8424,
    y1: 21.1875,
    x2: 90.9834,
    y2: 91.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyShare);
export default __webpack_public_path__ + "static/media/icon_empty_share.1f071c57e0bac15e4b3bea14faec491a.svg";
export { ForwardRef as ReactComponent };